module.exports = __webpack_public_path__ + "img/gamepad.202b76c8.png";